module.exports = __webpack_public_path__ + "img/sp-more-btn.ee0d791b.png";